import {Component, OnDestroy, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FullscreenService} from '../../../services/fullscreen/fullscreen.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {ExamService} from '../../../services/exam/exam.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-exam-index',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './exam-index.component.html',
  styleUrls: ['./exam-index.component.scss']
})
export class ExamIndexComponent implements OnInit, OnDestroy {

  loading = true;
  level: any;
  examResult: any;

  constructor(
    public deviceSrv: DeviceDetectorService,
    public route: ActivatedRoute,
    public langSrcSrv: LangSrcService,
    private levelSrv: GameLevelService,
    private examSrv: ExamService,
    private fullscreenSrv: FullscreenService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.level = await this.levelSrv.findById(this.route.snapshot.params.idLevel);
    // Si le niveau n'existe meme pas ou qu'il n'est pas de type examen blanc, on redirige vers l'accueil
    if (!this.level || !this.level.isExam) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode]);
      return;
    }
    this.examResult = await this.examSrv.findResultById(this.route.snapshot.params.idLevel);
    // On vérifie si l'examen a déjà été réalisé
    // S'il est en cours on redirige vers l'examen
    // S'il a déjà été réalisé on redirige vers la page d'affichage de la correction
    if (this.examResult && this.examResult.status && this.examResult.status !== 'FINISHED') {
      this.fullscreenSrv.open();
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'exam', this.route.snapshot.params.idLevel, 'exam']);
    } else if (this.examResult && this.examResult.status && this.examResult.status === 'FINISHED') {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'exam', this.route.snapshot.params.idLevel, 'result']);
    }

    this.loading = false;
  }

  async ngOnDestroy() {
    this.fullscreenSrv.close();
  }
  async close() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode]);
  }

  async startExam() {
    // On créer l'entité exam result
    // Puis on redirige vers la page de l'examen
    this.examResult = await this.examSrv.start(this.route.snapshot.params.idLevel).then(() => {
      this.fullscreenSrv.open();
      this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'exam', this.route.snapshot.params.idLevel, 'exam']);
    });
  }
}
